module.exports = __webpack_public_path__ + "img/07.1e657d2a.png";